/**
 * Sidebar entries the channels feature contributes — a contribution file the
 * shell merges into the route registry; nothing self-registers. Permissions
 * are the canonical strings from openapi/generated/route_policy.gen.go.
 */
import { Globe, Scale, Store } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const channelsNavEntries: NavEntry[] = [
  {
    path: "/channels/list",
    labelKey: "channels.nav.channels",
    icon: Store,
    permission: "channels.channel.read",
  },
  {
    path: "/channels/orders",
    labelKey: "channels.nav.orders",
    icon: Globe,
    permission: "channels.order.read",
  },
  {
    path: "/channels/reconciliation",
    labelKey: "channels.nav.reconciliation",
    icon: Scale,
    permission: "channels.reconciliation.read",
  },
];
